import { FC } from "react";
import { getCardProgress, getRaffleBadge } from "../model/cardBadge";
import type { RaffleBadge, RaffleBadgeSource } from "../model/cardBadge";
import type { RaffleRole } from "../model/selectHistory";

import styles from "./RaffleCardBadge.module.css";

interface Props {
  raffle: RaffleBadgeSource;
  role: RaffleRole | null;
}

const LABELS: Record<RaffleBadge, string> = {
  created: "Created",
  joined: "Joined",
  won: "Win",
};

// Правый верхний угол карточки: статус зрителя или прогресс по условиям.
export const RaffleCardBadge: FC<Props> = ({ raffle, role }) => {
  const badge = getRaffleBadge(raffle, role);
  if (badge) {
    return (
      <span className={`${styles.badge} ${styles[badge]}`}>
        {LABELS[badge]}
      </span>
    );
  }

  const progress = getCardProgress(raffle);
  if (progress === null) return null;

  return (
    <span className={styles.progress} title="Conditions completed">
      <span
        className={styles.track}
        role="progressbar"
        aria-label="Conditions completed"
        aria-valuenow={progress}
        aria-valuemin={0}
        aria-valuemax={100}
      >
        <span className={styles.bar} style={{ width: `${progress}%` }} />
      </span>
      <span className={styles.percent}>{progress}%</span>
    </span>
  );
};
